import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e063d020&scoped=true&"
import script from "./zPayConfirmationModal.js?vue&type=script&lang=js&"
export * from "./zPayConfirmationModal.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=e063d020&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e063d020",
  null
  
)

export default component.exports